/**
 * L2-P7: moved to @miq/platform-ui (directives/set-title/title.directive.ts). This shim keeps the old
 * import path working; new code should import from '@miq/platform-ui'.
 */
export { TitleDirective } from '@miq/platform-ui';
